import React from "react";
import { api } from "@/lib/api";
import { Sparkles, Package, Users, Briefcase, Mail, FileText, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const Stat = ({ icon: Icon, label, value, to }) => (
  <Link to={to} className="admin-card p-6 hover:border-[color:var(--sky-cyan)]/60 transition-colors block">
    <div className="flex items-start justify-between">
      <div>
        <div className="text-[10px] uppercase tracking-[0.22em] text-[color:var(--sky-admin-muted)] font-bold">{label}</div>
        <div className="mt-3 font-display font-black text-4xl text-white">{value}</div>
      </div>
      <Icon size={20} className="text-[color:var(--sky-cyan)]" />
    </div>
  </Link>
);

export default function AdminDashboard() {
  const [counts, setCounts] = React.useState({ services: 0, products: 0, team: 0, jobs: 0, apps: 0, msgs: 0 });

  React.useEffect(() => {
    (async () => {
      try {
        const [svc, prd, tm, jbs, aps, msgs] = await Promise.all([
          api.get("/services"), api.get("/products"), api.get("/team"), api.get("/jobs"),
          api.get("/applications"), api.get("/contact"),
        ]);
        setCounts({
          services: svc.data.length, products: prd.data.length, team: tm.data.length,
          jobs: jbs.data.length, apps: aps.data.length, msgs: msgs.data.length,
        });
      } catch { /* ignore */ }
    })();
  }, []);

  return (
    <div>
      <div className="overline text-[color:var(--sky-cyan)]">Overview</div>
      <h1 className="mt-3 font-display font-black text-white text-4xl">Welcome back, Super Admin.</h1>
      <p className="text-[color:var(--sky-admin-muted)] mt-2">Manage everything on skyverraconsulting from here.</p>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Stat icon={Sparkles} label="Services" value={counts.services} to="/admin/services" />
        <Stat icon={Package} label="Products" value={counts.products} to="/admin/products" />
        <Stat icon={Users} label="Team members" value={counts.team} to="/admin/team" />
        <Stat icon={Briefcase} label="Job posts" value={counts.jobs} to="/admin/jobs" />
        <Stat icon={FileText} label="Applications" value={counts.apps} to="/admin/applications" />
        <Stat icon={Mail} label="Messages" value={counts.msgs} to="/admin/messages" />
      </div>

      <div className="mt-10 admin-card p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="overline text-[color:var(--sky-cyan)]">Hidden</div>
            <h3 className="mt-2 font-display font-bold text-white text-xl">API Login</h3>
            <p className="mt-1 text-sm text-[color:var(--sky-admin-muted)] max-w-lg">Open your integrated 3rd-party API application. This tab is only visible inside the admin console.</p>
          </div>
          <Link to="/admin/api-login" className="admin-btn inline-flex items-center gap-2 shrink-0">
            Open <ExternalLink size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
